import { gql } from '@apollo/client';

export function regionsQuery({ cityId }) {
  const name = `RegionsQuery_${cityId}`;
  return gql`
    query ${name}($cityId: ID!) {
      regions(cityId: $cityId) {
        id
        name
        latitude
        longitude
        slug
      }
    }
  `;
}

const temp = 'just for eslint';

export default temp;
